import React, { useState, useRef, useEffect } from "react";
import logoo from "../images/logoo-removebg-preview.png";
import slide1img from "../images/slide1img.png";
import heroSectionVector from "../images/hero-section-vector.png";
import slide1 from "../images/slide1.jpg";
import slide2 from "../images/slide2.jpg";
import slide3 from "../images/slide3.jpg";
import slide4 from "../images/slide4.jpg";
import slide5 from "../images/slide5.jpg";
import slide6 from "../images/slide6.jpg";
import productBgMainCircle from "../images/main-bg-circle.png";
import productBottomCircle from "../images/bottom-circles.png";
import productTopCircle from "../images/top-circles.png";
import bacitromed from "../images/Bacitomed.png";
import strepto from "../images/strepto.png";
import floro from "../images/floro.png";
import asmulin from "../images/asmulin.png";
import avatar from "../images/Frame 1171277891.png";
import { Link } from "react-router-dom";
import "../styles/home.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import translations from "./translations";
import { useLanguage } from "./Context/LanguageContext";
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";

function Home() {
  const { language } = useLanguage();
  const [email, setemail] = useState("");
  const [password, setpasssword] = useState("");
  const [errMsg, seterrMsg] = useState("");
  const [successMsg, setsuccessMsg] = useState("");
  const sliderRef = useRef(null);

  const settings = {
    centerMode: true,
    centerPadding: "100px",
    slidesToShow: 1,
    // prevArrow: <SamplePrevArrow />,
    // nextArrow: <SampleNextArrow />,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          centerPadding: "400px",
        },
      },
      {
        breakpoint: 1300,
        settings: {
          centerPadding: "250px",
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 576,
        settings: {
          centerPadding: "50px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
    ],
  };
  const next = () => {
    sliderRef.current.slickNext();
  };

  const previous = () => {
    sliderRef.current.slickPrev();
  };
  useEffect(() => {
    // Function to count from 0 to the target number
    const animateCounters = () => {
      const counters = document.querySelectorAll(".count");

      counters.forEach((counter) => {
        const updateCount = () => {
          const target = +counter.getAttribute("data-target");
          const currentCount = +counter.innerText;

          // Determine how much to increment
          const increment = target / 200;

          if (currentCount < target) {
            // Add increment and update the counter text
            counter.innerText = Math.ceil(currentCount + increment);
            setTimeout(updateCount, 15);
          } else {
            counter.innerText = target; // Ensure the final value is set
          }
        };

        updateCount();
      });
    };

    // Observe when the element is in view using Intersection Observer
    const darkBox = document.querySelector(".key-achive-section");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounters(); // Start animation when element is in view
          observer.disconnect(); // Stop observing after animation starts
        }
      });
    });

    observer.observe(darkBox);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <main id="home">
        <section className="hero-section">
          <div className="container">
            <div
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <h1>{translations[language].heroSectionTitle}</h1>
              <h2>{translations[language].heroSectionSubTitle}</h2>
              <p>{translations[language].heroSectionParagraph}</p>
            </div>
            <picture
              data-aos="fade-right"
              data-aos-duration="1000"
              data-aos-delay="400"
            >
              <img src={heroSectionVector} alt="" srcSet="" />
            </picture>
          </div>
        </section>
        <section className="home-2nd-section">
          <div
            className="container centered-section-topic  "
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <h2>{translations[language].aboutSectionTitle}</h2>
            {/* <p>
            {translations[language].aboutSectionParagraph}
          </p> */}
          </div>
          <div>
            <div
              className="aboutUs-slider "
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <Slider ref={sliderRef} {...settings}>
                <div>
                  <picture>
                    <img src={slide1} alt="" />
                  </picture>
                </div>
                <div>
                  <picture>
                    <img src={slide2} alt="" />
                  </picture>
                </div>
                <div>
                  <picture>
                    <img src={slide3} alt="" />
                  </picture>
                </div>
                <div>
                  <picture>
                    <img src={slide4} alt="" />
                  </picture>
                </div>
                <div>
                  <picture>
                    <img src={slide5} alt="" />
                  </picture>
                </div>
              </Slider>
            </div>
            <div className="aboutUs-arrows-container">
              <span
                className="home-btn-main aboutUs-arrows-prev "
                data-aos="fade-left"
                data-aos-duration="1000"
                data-aos-delay="200"
                onClick={previous}
              >
                <i className="fa-solid fa-arrow-left"></i>
              </span>
              <span
                className="home-btn-main aboutUs-arrows-next "
                data-aos="fade-right"
                data-aos-duration="1000"
                data-aos-delay="200"
                onClick={next}
              >
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </div>
          </div>
        </section>
        <section className="our-services-section">
          <div className="container centered-section-topic">
            <h2 data-aos="fade-up" data-aos-duration="1000">
              {translations[language].servicesSectionTitle}
            </h2>
          </div>
          <div className="container">
            <div
              className="our-services-card"
              data-aos="flip-left"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div className="service-card-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <div className="service-card-content">
                <h3>{translations[language].servicesSection1stSlideTitle}</h3>
                <p>{translations[language].servicesSection1stSlideParagraph}</p>
              </div>
            </div>
            <div
              className="our-services-card"
              data-aos="flip-right"
              data-aos-duration="1000"
              data-aos-delay="400"
            >
              <div className="service-card-icon">
                <i className="fas fa-industry"></i>
              </div>
              <div className="service-card-content">
                <h3>{translations[language].servicesSection2ndSlideTitle}</h3>
                <p>{translations[language].servicesSection2ndSlideParagraph}</p>
              </div>
            </div>
            <div
              className="our-services-card"
              data-aos="flip-left"
              data-aos-duration="1000"
              data-aos-delay="600"
            >
              <div className="service-card-icon">
                <i className="fas fa-exchange-alt"></i>
              </div>
              <div className="service-card-content">
                <h3>{translations[language].servicesSection3rdSlideTitle}</h3>
                <p>{translations[language].servicesSection3rdSlideParagraph}</p>
              </div>
            </div>
            <div
              className="our-services-card"
              data-aos="flip-right"
              data-aos-duration="1000"
              data-aos-delay="800"
            >
              <div className="service-card-icon">
                <i className="fas fa-capsules"></i>
              </div>
              <div className="service-card-content">
                <h3>{translations[language].servicesSection4thSlideTitle}</h3>
                <p>{translations[language].servicesSection4thSlideParagraph}</p>
              </div>
            </div>
          </div>
        </section>
        <section className="Products-section">
          <div className="container centered-section-topic">
            <h2 data-aos="zoom-in" data-aos-duration="1000">
              {translations[language].mainProductsSectionTitle}
            </h2>
          </div>
          <div className="container">
            <div
              className="product-card"
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <img src={productBgMainCircle} alt="" />
              <img className="main-product-img" src={bacitromed} alt="" />
              <img
                className="product-top-circle"
                src={productTopCircle}
                alt=""
              />
              <img
                className="product-bottom-circle"
                src={productBottomCircle}
                alt=""
              />
              <div className="product-card-content">
                <h3>{translations[language].cardOneHeading}</h3>
                <p>{translations[language].cardOneContent}</p>
                <Link
                  className="type-1-btn"
                  to={`Products/SingleProduct/680791bb72bd860b35a48ef1`}
                >
                  <span>{translations[language].moreDetailsBTN}</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
            </div>
            <div
              className="product-card"
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-delay="400"
            >
              <img src={productBgMainCircle} alt="" />
              <img className="main-product-img" src={strepto} alt="" />
              <img
                className="product-top-circle"
                src={productTopCircle}
                alt=""
              />
              <img
                className="product-bottom-circle"
                src={productBottomCircle}
                alt=""
              />
              <div className="product-card-content">
                <h3>{translations[language].cardTwoHeading}</h3>
                <p>{translations[language].cardTwoContent}</p>
                <Link
                  className="type-1-btn"
                  to={`Products/SingleProduct/680782a8f08604a6fa569db1`}
                >
                  <span>{translations[language].moreDetailsBTN}</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
            </div>
            <div
              className="product-card"
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-delay="600"
            >
              <img src={productBgMainCircle} alt="" />
              <img className="main-product-img" src={floro} alt="" />
              <img
                className="product-top-circle"
                src={productTopCircle}
                alt=""
              />
              <img
                className="product-bottom-circle"
                src={productBottomCircle}
                alt=""
              />
              <div className="product-card-content">
                <h3>{translations[language].cardThreeHeading}</h3>
                <p>{translations[language].cardThreeContent}</p>
                <Link
                  className="type-1-btn"
                  to={`Products/SingleProduct/6807844cf08604a6fa569dba`}
                >
                  <span>{translations[language].moreDetailsBTN}</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
            </div>
            <div
              className="product-card"
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-delay="800"
            >
              <img src={productBgMainCircle} alt="" />
              <img className="main-product-img" src={asmulin} alt="" />
              <img
                className="product-top-circle"
                src={productTopCircle}
                alt=""
              />
              <img
                className="product-bottom-circle"
                src={productBottomCircle}
                alt=""
              />
              <div className="product-card-content">
                <h3>{translations[language].cardFourHeading}</h3>
                <p>{translations[language].cardFourContent}</p>
                <Link
                  className="type-1-btn"
                  to={`Products/SingleProduct/6807908572bd860b35a48eee`}
                >
                  <span>{translations[language].moreDetailsBTN}</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="medical-advice-section">
        <div className="container">
          <h2 className="wow animate__fadeInLeft" data-wow-duration="1s">Medical Advice</h2>
        </div>
        <div className="container">
          <div className="medical-advice-card wow animate__fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">
            <h3>Figma ipsum component</h3>
            <p>Figma ipsum component variant main layer. Object asset team figma style list selection mask.</p>
          </div>
          <div className="medical-advice-card wow animate__fadeInRight" data-wow-duration="1s" data-wow-delay="0.4s">
            <h3>Figma ipsum component</h3>
            <p>Figma ipsum component variant main layer. Object asset team figma style list selection mask.</p>
          </div>
          <div className="medical-advice-card wow animate__fadeInLeft" data-wow-duration="1s" data-wow-delay="0.6s">
            <h3>Figma ipsum component</h3>
            <p>Figma ipsum component variant main layer. Object asset team figma style list selection mask.</p>
          </div>
        </div>
      </section> */}
        <section className="key-achive-section">
          <h2
            className="text-center wow animate__fadeInUp"
            data-wow-duration="1s"
          >
            {translations[language].ourkeyachivements}
          </h2>
          <div className="container">
            <div
              className="key-achive-card wow animate__fadeInLeft"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
            >
              <div className="key-achive-icon">
                <i className="fa-solid fa-circle-check"></i>
              </div>
              <div className="key-achive-card-content">
                <div className="d-flex gap-2">
                  <h1 className="count" data-target="13">
                    0
                  </h1>
                </div>
                <h5>{translations[language].ourkeyachivements2}</h5>
              </div>
            </div>
            <div
              className="key-achive-card wow animate__fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.4s"
            >
              <div className="key-achive-icon">
                <i className="fa-solid fa-people-group"></i>
              </div>
              <div className="key-achive-card-content">
                <div className="d-flex gap-2">
                  <h1 className="count" data-target="8">
                    0
                  </h1>
                </div>
                <h5>{translations[language].ourkeyachivements1}</h5>
              </div>
            </div>
            <div
              className="key-achive-card wow animate__fadeInLeft"
              data-wow-duration="1s"
              data-wow-delay="0.6s"
            >
              <div className="key-achive-icon">
                <i className="fa-solid fa-boxes-packing"></i>
              </div>
              <div className="key-achive-card-content">
                <div className="d-flex gap-2">
                  <h1 className="count" data-target="35">
                    0
                  </h1>
                </div>
                <h5>{translations[language].ourkeyachivements4}</h5>
              </div>
            </div>
            <div
              className="key-achive-card wow animate__fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.8s"
            >
              <div className="key-achive-icon">
                <i className="fa-solid fa-user-check"></i>
              </div>
              <div className="key-achive-card-content">
                <div className="d-flex gap-2">
                  <h1 className="count" data-target="5000">
                    0
                  </h1>
                  <h1>+</h1>
                </div>
                <h5>{translations[language].ourkeyachivements3}</h5>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Home;
